<app-smash-message-modal
    [title]="'LANGUAGE_LOAD_ERROR_TITLE' | translate"
    [description]="'LANGUAGE_LOAD_ERROR_DESCRIPTION' | translate"
    [closeLabel]="'LANGUAGE_LOAD_ERROR_CLOSE' | translate"
    (closed)="ref.close()">
</app-smash-message-modal>
